import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiResponse } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';
import { forkJoin, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InnerPageToOpenService {
  constructor(private http: HttpClient) {}

  getparams(filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('status', filterData.status ? filterData.status.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    return params;
  }

  getAllBusinessCard(filterData: IPaginationParams) {
    const params = this.getparams({ ...filterData, status: 'Active' });
    return this.http.get<ApiResponse>('/v1/admin/business-card', { params });
  }

  getScannedInvoices(params: IPaginationParams) {
    const httpParams = this.getparams(params);
    return this.http.get<ApiResponse>('/v1/admin/invoices', { params: httpParams });
  }

  getAllNirlatConsultant(filterData: IPaginationParams) {
    const params = this.getparams(filterData);
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/nirlat-consultant', { params });
  }

  getAllColorCombinations(params: IPaginationParams) {
    const httpParams = this.getparams(params);
    return this.http.get<ApiResponse>('/v1/admin/color-combination', { params: httpParams });
  }

  colorList() {
    return this.http.get<ApiResponse>(`/v1/admin/color-combination/color-list`);
  }

  getAllBusiness(filterData: IPaginationParams) {
    const params = this.getparams(filterData);
    return this.http.get<ApiResponse>('/v1/admin/business', { params });
  }

  getAllPosts(params: any, lang?: string) {
    return this.http.get<ApiResponse>('/v1/admin/posts', { params, headers: { lang: lang || 'he' } });
  }

  getAllNirlatGifts(params: IPaginationParams) {
    const httpParams = this.getparams(params);
    return this.http.get<ApiResponse>('/v1/admin/nirlat-gifts', { params: httpParams });
  }

  getAllProduct(filterData: IPaginationParams) {
    const params = this.getparams(filterData);
    return this.http.get<ApiResponse>('/v1/admin/product', { params });
  }

  getAllBusinessSales(params: IPaginationParams) {
    const httpParams = this.getparams(params);
    return this.http.get<ApiResponse>('/v1/admin/business-sales', { params: httpParams });
  }

  getPromotion() {
    return this.http.get<ApiResponse>('/v1/admin/nirlat-promotion/active-promotion');
  }

  getAllNirlatTips(params: IPaginationParams) {
    const httpParams = this.getparams(params);
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/nirlat-tips', { params: httpParams });
  }

  getAllNirlatVideos(params: IPaginationParams) {
    const httpParams = this.getparams(params);
    return this.http.get<ApiResponse>('/v1/admin/nirlat-consultation/instructional-video', { params: httpParams });
  }

  getNirlatConsultantions(params: IPaginationParams) {
    const api1$ = this.getAllNirlatTips(params);
    const api2$ = this.getAllNirlatVideos(params);

    return forkJoin([api1$, api2$]).pipe(
      map(([responseTips, responseVideos]) => {
        const videoData = responseVideos.data.map((responseVideo: any) => ({
          id: responseVideo._id,
          name: responseVideo.name,
          type: 'video',
        }));
        const tipsData = responseTips.data.map((responseTip: any) => ({
          id: responseTip._id,
          name: responseTip.detail?.title,
          type: 'tip',
        }));
        return {
          data: [...videoData, ...tipsData],
        };
      }),
    );
  }

  getPageApiFunction(page: string) {
    const params: IPaginationParams = {
      pageNum: 0,
      pageLimit: 'all',
    };
    const pageApiMapping: {
      [key: string]: Observable<any>;
    } = {
      BUSINESS_CARD_PAGE: this.getAllBusinessCard(params),
      SEND_INVOICE_PAGE: this.getScannedInvoices(params),
      NIRLAT_CONSULTATION_PAGE: this.getNirlatConsultantions(params),
      NIRLAT_COLORS_PAGE: this.colorList(),
      COLOR_COMBINATION_PAGE: this.getAllColorCombinations(params),
      BUSINESS_LIST_PAGE: this.getAllBusiness(params),
      NIRLAT_TEAM_PAGE: this.getAllPosts(params),
      GIFT_PAGE: this.getAllNirlatGifts(params),
      PRODUCT_PAGE: this.getAllProduct(params),
      NIRLAT_PROMOTION_PAGE: this.getPromotion(),
    };

    return pageApiMapping[page];
  }
}
